import { render, staticRenderFns } from "./ChartHistory.vue?vue&type=template&id=8e4583a2&scoped=true&"
import script from "./ChartHistory.vue?vue&type=script&lang=js&"
export * from "./ChartHistory.vue?vue&type=script&lang=js&"
import style0 from "./ChartHistory.vue?vue&type=style&index=0&id=8e4583a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4583a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
